module.exports = __webpack_public_path__ + "img/23400.db059536.jpg";